module.exports = __webpack_public_path__ + "static/media/hurdcoLogo.39fcaf05.jpeg";